<template>
  <div
    v-if="$store.getters.isLoggedIn"
    id="file"
    class="page">
    <!-- Drawer -->
    <v-navigation-drawer
      v-model="isDrawerOpen"
      width="250px"
      mobile-break-point="0"
      floating
      app>
      <div class="h-100 d-flex flex-column page-drawer">
        <div class="page-logo-container mx-auto my-5">
          <!-- DelMar Logo -->
          <router-link
            id="logo"
            to="/content">
            <img
              src="../assets/img/logo.png"
            />
          </router-link>
          <!-- / DelMar Logo -->
        </div>

        <div class="page-navigation-container d-flex flex-column flex-grow-1">
          <!-- Main Navigation -->
          <MainNavigation />
          <!-- / Main Navigation -->

          <div class="mx-5 my-5 pb-5">
            <v-btn
              @click="$refs.fileUpload.click()"
              color="primary"
              type="button"
              block>
              <v-icon size="12">mdi-plus</v-icon>
              Upload File
            </v-btn>
            <input
              ref="fileUpload"
              @input="uploadFile"
              type="file"
              hidden
            />
          </div>
        </div>

        <!-- User Account Menu -->
        <UserMenu class="mt-auto" />
        <!-- User Account Menu -->
      </div>
    </v-navigation-drawer>
    <!-- / Drawer -->

    <!-- File Page Content -->
    <v-content class="h-100">
      <v-toolbar
        class="my-2 page-toolbar">
        <v-app-bar-nav-icon
          class="page-drawer-toggle"
          @click="isDrawerOpen = !isDrawerOpen">
        </v-app-bar-nav-icon>

        <v-toolbar-title
          class="pl-0">
          <h4 class="d-flex align-center margin-right">
            {{$store.state.user.projectName}}
          </h4>
        </v-toolbar-title>

        <!-- Page Filter -->
        <div
          class="page-filter">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            clearable
            outlined
            filled
            hide-details
            v-model="fileFilter">
          </v-text-field>
        </div>
        <!-- / Page Filter -->

        <!-- Preview / Publish -->
          <PreviewPublish />
        <!-- / Preview / Publish -->
      </v-toolbar>

      <v-divider class="mx-5"></v-divider>

      <!-- File List -->
      <FileList :files="files" />
      <!-- / File List -->
    </v-content>
    <!-- / File Page Content -->
  </div>
</template>

<script>
import _ from 'lodash';
import MainNavigation from '../components/MainNavigation.vue';
import PreviewPublish from '../components/PreviewPublish.vue';
import UserMenu from '../components/UserMenu.vue';
import FileList from '../components/FileList.vue';

export default {
  name: 'Files',
  components: {
    MainNavigation,
    PreviewPublish,
    UserMenu,
    FileList,
  },
  data() {
    return {
      isDrawerOpen: true,
      fileFilter: '',
    };
  },
  computed: {
    files() {
      return _.filter(
        this.$store.state.files,
        (file) => {
          const fileFilter = this.fileFilter.toLowerCase();
          const filenameMatch = file.fileName.includes(fileFilter);
          return !fileFilter || filenameMatch;
        },
      );
    },
  },
  methods: {
    uploadFile() {
      const [file] = this.$refs.fileUpload.files;
      this.$refs.fileUpload.value = '';
      this.$store.dispatch('uploadFile', { file });
    },
  },
};
</script>

<style lang="scss"></style>
